/**
 * @desc 基本常用工具集
 */
import Cookie from 'js-cookie';
import Cookies from 'js-cookie';

/**
 * @desc Base64
 * @type {{ec: (function(*=)), dc: (function(*=))}}
 */
export const Base64 = {
  ec: (val) => {
    try {
      return window.btoa(val);
    } catch (e) {
      return val;
    }
  },
  dc: (val) => {
    try {
      return window.atob(val);
    } catch (e) {
      return val;
    }
  },
};
/**
 * @desc 解码
 * @param target
 * @return {*}
 */
export const dc = (target) => {
  return Base64.dc(target);
};
/**
 * @desc 对象转queryString
 * @param obj
 * @return {string}
 */
export const obj2qs = (obj) => (obj instanceof Object ?
  Object.keys(obj).reduce((o, c) => {
    const v = obj[c];
    return `${o}${c}=${typeof v === 'object' ? JSON.stringify(v) : v}&`;
  }, '').slice(0, -1) :
  '');
/**
 * @desc 添加对象参数至url
 * @param url
 * @param obj
 * @return {string}
 */
export const addParams2url = (url, obj) => {
  const str = obj2qs(obj);
  if (!str) return url;
  return `${url}`.includes('?') ? `${url}&${str}` : `${url}?${str}`;
};
/**
 * desc常用类型
 * @type {{number: string, boolean: string, string: string, array: string, function: string, error: string, object: string}}
 */
export const typeMap = {
  undefined: 'undefined',
  null: 'null',
  boolean: 'boolean',
  number: 'number',
  string: 'string',
  symbol: 'symbol',
  object: 'object',
  function: 'function',
  array: 'array',
  error: 'error',
};
/**
 * @desc 获取value类型
 * @param value
 * @return {string}
 */
export const typeQuery = (value) => ({}).toString.call(value).toLowerCase().slice(8, -1).trim();
Object.keys(typeMap).forEach((key) => typeQuery[key] = typeMap[key]);
/**
 * @desc 获取token
 * @return {*}
 */
export const getToken = () => dc(Cookie.get('123cx@token'));
/**
 * @desc 清除token相关信息
 */
export const removeTokenInfo = () => {
  let domainVal = '';
  if (location.hostname.indexOf('.com') >= 0) {
    domainVal = `.${location.hostname.split('.').slice(-2).join('.')}`;
  } else {
    domainVal = location.hostname;
  }
  // Cookie.set('123cx@token', '');
  Cookie.set('123cx@token', '', { domain: domainVal });
};
const getBaseOffset = (el, offset) => {
  const op = el.offsetParent;
  if (!el) return new Error('Target does not exist.');
  if (!offset) {
    offset = { top: el.offsetTop, left: el.offsetLeft };
  } else {
    offset = { top: offset.top + el.offsetTop, left: offset.left + el.offsetLeft };
  }
  if (!op) {
    return offset;
  } else {
    return getBaseOffset(op, offset);
  }
};
const getScrollOffset = (el, offset) => {
  const parentNode = el.parentNode;
  if (!el) return new Error('Target does not exist.');
  if (!offset) offset = { top: 0, left: 0 };
  if (!parentNode) {
    return offset;
  } else {
    offset = { top: offset.top + (parentNode.scrollTop || 0), left: offset.left + (parentNode.scrollLeft || 0) };
    return getScrollOffset(parentNode, offset);
  }
};
/**
 * @desc 获取窗口定位
 * @param el
 * @return {{top: number, left: number}}
 */
export const getOffset = (el) => {
  const position = window.getComputedStyle(el).position;
  const baseOffset = getBaseOffset(el);
  const scrollOffset = position === 'fixed' ? { top: 0, left: 0 } : getScrollOffset(el);
  const top = baseOffset.top - scrollOffset.top;
  const left = baseOffset.left - scrollOffset.left;
  return { top, left };
};
